<template lang="pug">
  div
    el-collapse(v-model='activeNames')
      el-collapse-item(title='Οι Συνομιλίες μου', name='1', v-loading="deletingRoom")
        div Μπορείτε να διαγράψετε τις παρακάτω συνομιλίες ή να αποχωρήσετε από αυτές
        el-table(:data='privateChats' style='width: 100%')
          el-table-column(prop='label' label='Όνομα' width='200')
            template(slot-scope='scope')
              span(style='margin-left: 10px') {{ scope.row.label }}
          el-table-column(prop="members" label='Συμμετέχοντες' style='width: 60%')
            template(slot-scope='scope')
              span(style='margin-left: 10px') {{ scope.row.users.map(user => user.name).join(', ') }}
          el-table-column(fixed='right' label='Ενέργειες' width='100')
            template(slot-scope='scope')
              el-tooltip(class="item" effect="dark" content="Διαγραφή Συνομιλίας" placement="top-start" v-if="isChatAdmin(scope.row)")
                el-button(type='text', @click='roomDelete(scope.row.id)', icon="el-icon-delete")
              el-tooltip(class="item" effect="dark" content="Αποχώρηση από Συνομιλία" placement="top-start" v-else)
                el-button(type='text', @click='removeMe(scope.row.id)', icon="el-icon-remove")
      el-collapse-item(title='Ανοιχτές Συνομιλίες' name='2')
        div Δημόσιες συνομιλίες που μπορείτε να συμμετέχετε
        el-table(:data='publicChats' style='width: 100%')
          el-table-column(prop='label' label='Όνομα' width='200')
            template(slot-scope='scope')
              span(style='margin-left: 10px') {{ scope.row.label }}
          el-table-column(prop="members" label='Συμμετέχοντες' style='width: 60%')
            template(slot-scope='scope')
              span(style='margin-left: 10px') {{ scope.row.users.map(user => user.name).join(', ') }}
          el-table-column(fixed='right' label='Ενέργειες' width='150')
            template(slot-scope='scope')
              el-tooltip(class="item" effect="dark" content="Διαγραφή Συνομιλίας" placement="top-start" v-if="isChatAdmin(scope.row)")
                el-button(type='text', @click='roomDelete(scope.row.id)', icon="el-icon-delete")
              el-tooltip(class="item" effect="dark" content="Αποχώρηση από Συνομιλία" placement="top-start" v-else-if="inMyPublicChats(scope.row)")
                el-button(type='text', @click='removeMe(scope.row.id)', icon="el-icon-remove")
              el-tooltip(class="item" effect="dark" content="Εγγραφή στη Συνομιλία" placement="top-start" v-else)
                el-button(type='text', @click='addMe(scope.row.id)', icon="el-icon-circle-plus")
        //-   | should the admin be the admin of chatrooms that cannot be changed like board chatrooms or the public one?
      el-collapse-item(title='Νέα Συνομιλία - Προσθήκη Χρηστών' name='3' v-loading='creatingChatRoom')
        el-form(label-width='180px', :inline='true')
          el-form-item(label='Επιλέξτε Συνομιλία')
            el-switch(
              v-model="newOrExisting"
              active-text="Νέα"
              inactive-text="Υπάρχουσα"
              @change="newOrExistingChanged")
          el-form-item(label='Όνομα Συνομιλίας', v-if="newOrExisting")
            el-input(placeholder='Όνομα',
              v-model='roomName',
              v-on:keyup.enter.native='createFindRoom',
              suffix-icon="el-icon-search")
            el-checkbox(v-model="private") Ιδιωτική Συνομιλία
          el-form-item(label='Όνομα Συνομιλίας', v-if="!newOrExisting")
            el-select(
              v-model='roomName',
              @change="existingRoomSelected",
              placeholder='Συνομιλίες',
              filterable)
              el-option(v-for="chat in myAdminChats",
              :key="chat.id",
              :label="chat.label",
              :value="chat.id")
          el-button(type='primary' @click='createFindRoom') {{ newOrExisting ? 'Δημιουργία' : 'Εύρεση' }}
        div(v-show="selectChatUsers") Προσθήκη-Αφαίρεση Χρηστών
          el-transfer(
            filterable=''
            :filter-method='filterMethod'
            filter-placeholder='Φίλτρο για Χρήστες'
            :titles="['Διαθέσιμοι Χρήστες', 'Μέλη Συνομιλίας']",
            v-model='usersToAdd'
            :data='users'
            @change="modifiedUsers")
      el-collapse-item(title='Avatar', name='4')
        el-form(label-width='180px', :inline='true')
          el-form-item(label='Επιλέξτε Avatar', v-loading="savingAvatar")
            el-select(
              v-model='avatarSelected',
              @change="existingAvatarSelected",
              placeholder='Avatar',
              filterable)
              el-option(v-for="avatar in avatars",
                :key="avatar.id",
                :label="avatar.label",
                :value="avatar.label")
            el-button(type='primary' @click='saveAvatar') Αποθήκευση
        img(:src="avatarImage" alt="Avatar")
</template>

<script>
import { mapGetters } from 'vuex'
import sharedMethods from '../sharedMethods.js'

export default {
  mixins: [sharedMethods],
  data () {
    return {
      avatarSelected: '',
      private: true,
      selectedUsersToRemove: [],
      selectedUsersToAdd: [],
      selectedChatId: '',
      selectedUserId: '',
      newOrExisting: '',
      deletingRoom: false,
      roomName: '',
      roomId: '',
      usersToAdd: [],
      filterMethod (query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
      },
      activeNames: ['1']
    }
  },
  methods: {
    saveAvatar () {
      this.$store.dispatch('SAVE_AVATAR', {avatar: this.avatarSelected})
    },
    existingAvatarSelected (val) {
      this.avatarSelected = val
    },
    isChatAdmin (room) {
      const isCurrentUsersRoom = room.users
        .find(user => user.id === (this.currentUser ? this.currentUser.id : ''))
      return isCurrentUsersRoom ? isCurrentUsersRoom.admin : false
    },
    inMyPublicChats (room) {
      return this.myPubliChats.map(chat => chat.id).includes(room.id)
    },
    modifiedUsers (rightUserIds, direction, movingUserIds) {
      if (direction === 'left') {
        movingUserIds.forEach(userId => {
          this.$store.dispatch('REMOVE_USER_FROM_CHATROOM', {chatId: this.roomName, userId: userId})
        })
      } else if (direction === 'right') {
        movingUserIds.forEach(userId => {
          this.$store.dispatch('ADD_USER_TO_CHATROOM', {chatId: this.roomName, userId: userId})
        })
      }
    },
    existingRoomSelected () {
      this.usersToAdd = []
    },
    newOrExistingChanged (val) {
      this.roomName = ''
      this.usersToAdd = []
    },
    addMe (id) {
      this.$confirm('ΠΡΟΣΟΧΗ! Αυτή η ενέργεια θα σας προσθέσει σε αυτή την ομάδα συζήτησης', 'Warning', {
        confirmButtonText: 'Προσθήκη',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        this.deletingRoom = true
        this.$store.dispatch('ADD_USER_TO_CHATROOM', {userId: this.currentUser.id, chatId: id})
          .then(res => {
            this.deletingRoom = false
          })
          .catch(err => {
            console.log(err)
            this.deletingRoom = false
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Η διαγραφή ακυρώθηκε'
        })
      })
    },
    removeMe (id) {
      this.$confirm('ΠΡΟΣΟΧΗ! Αυτή η ενέργεια θα σας αφαιρέση από αυτή την ομάδα συζήτησης', 'Warning', {
        confirmButtonText: 'Αφαίρεση',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        this.deletingRoom = true
        this.$store.dispatch('REMOVE_USER_FROM_CHATROOM', {userId: this.currentUser.id, chatId: id})
          .then(res => {
            this.deletingRoom = false
          })
          .catch(err => {
            console.log(err)
            this.deletingRoom = false
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Η διαγραφή ακυρώθηκε'
        })
      })
    },
    roomDelete (id) {
      this.$confirm('ΠΡΟΣΟΧΗ! Αυτή η ενέργεια θα διαγράψει μόνιμα την συνομιλία με όλα τα μηνύματα της. Συνέχεια?', 'Warning', {
        confirmButtonText: 'Μόνιμη Διαγραφή',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        const isAdmin = this.myChats
          .find(chat => chat.id === id).users
          .find(user => user.id === (this.currentUser ? this.currentUser.id : ''))
          .admin
        if (isAdmin) {
          this.deletingRoom = true
          this.$store.dispatch('DELETE_CHATROOM', id)
            .then(res => {
              this.deletingRoom = false
            })
            .catch(err => {
              console.log(err)
              this.deletingRoom = false
            })
        } else {
          this.$notify.warning({
            title: `Ανεπιτυχής Ενέργεια`,
            message: `Δεν μπορείτε να διαγράψετε συνομιλίες που δεν δημιουργήσατε`,
            offset: 100
          })
        }
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed'
        // })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Η διαγραφή ακυρώθηκε'
        })
      })
    },
    createFindRoom () {
      if (this.newOrExisting) {
        this.$store.dispatch('CREATE_CHATROOM', {roomName: this.roomName, isPrivate: this.private})
      } else {
        this.$store.dispatch('GET_CURRENT_CHATROOM_USERS', this.roomName).then(users => {
          this.usersToAdd = users.map(user => user.id)
        })
      }
    }
  },
  computed: {
    avatarImage (val) {
      return this.avatarSelected
        ? require('../../../assets/' + this.avatarSelected + '.jpg')
        : this.myAvatar
          ? require('../../../assets/' + this.myAvatar + '.jpg')
          : ''
    },
    myAdminChats () {
      return this.myChats
        .filter(chat => chat.users
          .find(user => user.admin).id === (this.currentUser ? this.currentUser.id : ''))
    },
    selectChatUsers () {
      return !this.newOrExisting && this.roomName && this.usersToAdd.length > 0
    },
    users () {
      return this.allUsers.map(user => {
        return {
          label: `${user.name}, ${user.surname}`,
          key: user.id,
          initial: user.id
        }
      })
    },
    usersNameLabels () {
      return this.internalUsers.map(function (user) {
        return {
          value: user.id,
          label: user.name + ' ' + user.surname
        }
      })
    },
    ...mapGetters({
      myChats: 'myChats',
      publicChats: 'publicChats',
      privateChats: 'privateChats',
      modifyingRoomUsers: 'modifyingRoomUsers',
      allUsers: 'allUsers',
      currentUser: 'currentUser',
      isAdmin: 'isAdmin',
      myPubliChats: 'myPubliChats',
      avatars: 'avatars',
      myAvatar: 'myAvatar',
      savingAvatar: 'savingAvatar',
      creatingChatRoom: 'creatingChatRoom'
    })
  }
}
</script>

<style lang="scss" scoped>
.el-collapse-item {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/chat/manageChatRoom.vue